var map = {
	"./abercrombie.svg": 981,
	"./anthropologie.svg": 982,
	"./aritzia.svg": 983,
	"./bar.svg": 984,
	"./bergdorf.svg": 985,
	"./dibs.svg": 986,
	"./gucci.svg": 987,
	"./revolve.svg": 988,
	"./sephora.svg": 989,
	"./target.svg": 990,
	"./tecovas.svg": 991,
	"./wayfair.svg": 992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1789;